import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon, IonItem, IonLabel } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { qrCodeOutline } from 'ionicons/icons';
import type { FormShortLinkListRow } from './form-short-link-list-row.model';

addIcons({ qrCodeOutline });

@Component({
  selector: 'crowdctrl-form-short-link-qr-row',
  standalone: true,
  imports: [CommonModule, IonItem, IonLabel, IonIcon],
  templateUrl: './form-short-link-qr-row.component.html',
  styleUrl: './form-short-link-qr-row.component.css',
})
export class FormShortLinkQrRowComponent {
  @Input({ required: true }) row!: FormShortLinkListRow;

  @Output() selected = new EventEmitter<FormShortLinkListRow>();

  get title(): string {
    return this.row.label?.trim() || `QR ${this.row.id.slice(0, 8)}`;
  }

  onRowClick(): void {
    this.selected.emit(this.row);
  }
}
